/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_UploadingInputs */



/**
* | output |
* | --- |
* | "Uploading" |
*
* @param {Rte_UploadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_uploading = /** @type {((inputs?: Rte_UploadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_UploadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bezig met uploaden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi en cours")
	return /** @type {LocalizedString} */ ("Uploading")
});